import React from "react";
import { format } from "date-fns";
import { Theme } from "@mui/material";
import { toGermanNumberFormat } from "@helpers";

interface ChartTooltipProps {
  value: number;
  date: Date;
  color: string;
  theme: Theme;
}

export const ChartTooltip = ({
  value,
  date,
  color,
  theme,
}: ChartTooltipProps) => {
  const containerStyle: React.CSSProperties = {
    display: "flex",
    flexDirection: "column",
    borderRadius: "10px",
    backgroundColor: theme.palette.background.tooltipPrimary,
    border: `1px solid ${theme.palette.border.tooltipPrimary}`,
    padding: "14px 18px 13px 20px",
    minWidth: "120px",
  };

  const itemStyle: React.CSSProperties = {
    display: "flex",
  };

  const legendCircleContainerStyle: React.CSSProperties = {
    height: "12px",
    width: "12px",
    marginRight: "5px",
    marginTop: "4px",
  };

  const circleStyle: React.CSSProperties = {
    display: "inline-block",
    boxSizing: "unset",
    width: "12px",
    height: "12px",
    borderRadius: "50%",
    backgroundColor: color,
  };

  const titleContainerStyle: React.CSSProperties = {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
  };

  const titleStyle: React.CSSProperties = {
    color: theme.palette.text.onTooltipPrimary,
    fontFamily: theme.typography.fontFamily,
    fontSize: theme.typography.h3.fontSize as string,
    fontWeight: theme.typography.h3.fontWeight as number,
    lineHeight: theme.typography.h3.lineHeight as string,
    margin: 0,
  };

  const subtitleStyle: React.CSSProperties = {
    color: theme.palette.text.onTooltipPrimarySub,
    fontFamily: theme.typography.fontFamily,
    fontSize: "11px",
    lineHeight: "16px",
    margin: 0,
  };

  return (
    <div style={containerStyle}>
      <div style={itemStyle}>
        <div style={legendCircleContainerStyle}>
          <div style={circleStyle} />
        </div>
        <div style={titleContainerStyle}>
          <p style={titleStyle}>{toGermanNumberFormat(value)}</p>
          <p style={subtitleStyle}>{format(date, "dd.MM.yyyy")}</p>
        </div>
      </div>
    </div>
  );
};
